export const LOADER = "LOADER";
export const SET_LOGGED_IN_USER = "SET_LOGGED_IN_USER";
